<im-modal>
  <im-modal-header (dismiss)="dismissModal()">
    {{
      (link()
        ? 'homepage_module.portal_edit_l'
        : 'homepage_module.portal_create_l'
      ) | translate
    }}
  </im-modal-header>

  <div modal-content class="homepage-link-modal" [formGroup]="formGroup">
    <p class="im:body homepage-link-modal__description">
      {{
        (link()
          ? 'homepage_module.portal_edit_description_l'
          : 'homepage_module.portal_create_description_l'
        ) | translate
      }}
    </p>

    <app-form-field>
      <app-form-field-label>{{
        'homepage_module.portal_name_l' | translate
      }}</app-form-field-label>
      <input
        appInput
        type="text"
        required
        formControlName="name"
        class="form-control mb10"
      />
    </app-form-field>

    <im-form-field class="mb-3">
      <im-select
        [label]="'homepage_module.portal_type_l' | translate"
        [options]="homepageModuleTypes"
        formControlName="type"
      >
        <ng-template let-item>{{ item.name | translate }}</ng-template>
      </im-select>
    </im-form-field>

    <div class="homepage-link-modal__footer">
      <button im-button class="inverted" (click)="dismissModal()">
        {{ 'CANCEL_A' | translate }}
      </button>
      <button
        im-button
        class="primary"
        [disabled]="formGroup.invalid"
        (click)="save()"
      >
        {{
          (link()
            ? 'homepage_module.portal_edit_a'
            : 'homepage_module.portal_create_a'
          ) | translate
        }}
      </button>
    </div>
  </div>
</im-modal>
